import {PayoutSettingsFlow} from "../../connect-bank-account";
import {FetchAccountDetailsProvider} from "../../connect-bank-account/context/fetch-account-details.context";
import {PayoutSettingsProvider} from "./context";

export function PayoutSettingsTab() {
  return (
    <div>
      <FetchAccountDetailsProvider>
        <PayoutSettingsProvider>
          <PayoutSettingsFlow />
        </PayoutSettingsProvider>
      </FetchAccountDetailsProvider>
    </div>
  );
}
